export const mainMenuText = 'Menu Principal'
export const notificationsText = 'Notificaciones'
export const selectChildText = 'Seleccionar institución'
export const signOffText = 'Cerrar sesión'
export const thereIsNotNotificationsText = 'No hay notificaciones que mostrar'
